import { SelectOption } from "@/@types/SelectOption";
import { IMarcaProduto } from "@/interfaces/IMarcaProduto";
import { api } from "@/services/api";
import { marcaProdutoAction } from "@/store/actions/marcaProduto";
import { getMarcaProdutoSynced } from "@/store/reducers/marcaProduto";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export function useMarcaProduto() {
  const { user } = useAuth();
  const listaMarcasProdutos = useSelector(getMarcaProdutoSynced);
  const appDispatch = useDispatch();
  const { sync } = marcaProdutoAction;
  const [marcasOptions, setMarcasOptions] = useState<SelectOption[]>([]);

  const sincronizarMarcasProdutos = (marcas: IMarcaProduto[]) => {
    appDispatch(sync(marcas));
  };

  const getMarcasProdutosApi = async () => {
    const { data } = await api.get<IMarcaProduto[]>(`/marcas-produto/todas`, {
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
      },
    });
    return data;
  };

  const getMarcaProdutoById = (id: number) => {
    return listaMarcasProdutos.find((marca) => marca.id === id);
  };

  const getMarcasProdutosByEstabelecimento = (estabelecimentoId: number) => {
    const marcas = listaMarcasProdutos.filter(
      (marca) => marca.estabelecimento.id === estabelecimentoId
    );
    const options = marcas.map((marca) => ({
      label: marca.nome,
      value: marca.id,
    }));
    setMarcasOptions(options);
  };

  return {
    listaMarcasProdutos,
    sincronizarMarcasProdutos,
    getMarcasProdutosApi,
    getMarcaProdutoById,
    marcasOptions,
    getMarcasProdutosByEstabelecimento,
  };
}
